import { ThemeProvider } from '@material-tailwind/react/context/theme';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import { QueryClientProvider } from 'react-query';
import Footer from './components/footer';
import Navbar from './components/navbar';
import { StagingBanner } from './components/staging-banner/staging-banner';
import { queryClient } from './lib/react-query-client';
import { theme } from './material-tailwind-theme';
import { AuthStateProvider } from './providers/auth-state-provider';
import { AppRouter } from './routers/app-router';
import * as Sentry from '@sentry/react';

function App() {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
  );

  return (
    <Sentry.ErrorBoundary>
      <StagingBanner />
      <AuthStateProvider>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider value={theme}>
            <AppRouter />
          </ThemeProvider>
        </QueryClientProvider>
      </AuthStateProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
